// Site-wide accessibility enhancements (WCAG audit fixes)
(function() {
  if (window.__siteAccessibilityInit) return;
  window.__siteAccessibilityInit = true;

  function stripHtml(html) {
    var el = document.createElement('div');
    el.innerHTML = html || '';
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function getWishlistCount() {
    var countEl = document.querySelector('.wishlist-hero-items-count-text, .wishlist-hero-items-count');
    if (!countEl) return 0;
    var match = (countEl.textContent || '').match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  }

  function updateNavWishlistLabel() {
    var link = document.querySelector('a.nav-wishlist');
    if (!link) return;
    var count = getWishlistCount();
    var label = count > 0 ? 'Wishlist, ' + count + ' item' + (count === 1 ? '' : 's') : 'Wishlist';
    link.setAttribute('aria-label', label);
    link.removeAttribute('aria-labelledby');
    var svg = link.querySelector('svg');
    if (svg) svg.setAttribute('aria-hidden', 'true');
  }

  function updateNavCartLabel() {
    var link = document.getElementById('nav-cart-link') || document.querySelector('.site-control a.cart-icon--basket1, .site-control a.cart-icon--basket2');
    if (!link) return;
    var countEl = link.querySelector('div');
    var count = countEl ? parseInt((countEl.textContent || '0').trim(), 10) || 0 : 0;
    var label = count > 0 ? 'Cart, ' + count + ' item' + (count === 1 ? '' : 's') : 'Cart';
    link.setAttribute('aria-label', label);
    var svg = link.querySelector('svg');
    if (svg) {
      svg.setAttribute('aria-hidden', 'true');
      var title = svg.querySelector('title');
      if (title) title.remove();
    }
  }

  function markTrackingPixelsDecorative() {
    document.querySelectorAll('img[src*="roeye.com"], img[src*="lantern.roeye"]').forEach(function(img) {
      if (!img.hasAttribute('alt')) img.setAttribute('alt', '');
      img.setAttribute('aria-hidden', 'true');
    });
  }

  function enhanceSearchCloseButton() {
    var close = document.querySelector('#search-modal [data-modal-close]');
    if (!close || close.getAttribute('data-a11y-enhanced')) return;
    close.setAttribute('data-a11y-enhanced', 'true');
    close.setAttribute('role', 'button');
    close.setAttribute('aria-label', 'Close search');
    if (close.tagName === 'A') {
      close.setAttribute('href', '#');
    }
  }

  function enhanceMobileMenuClose() {
    var menu = document.getElementById('page-menu');
    if (!menu) return;
    if (!menu.querySelector('.mobile-menu-close-btn')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mobile-menu-close-btn cc-popup-close';
      btn.setAttribute('aria-label', 'Close menu');
      btn.setAttribute('data-modal-close', '');
      btn.innerHTML = '<span aria-hidden="true">&times;</span>';
      var inner = menu.querySelector('.inner');
      if (inner) inner.insertBefore(btn, inner.firstChild);
    }
    menu.setAttribute('role', 'dialog');
    menu.setAttribute('aria-modal', 'true');
    syncMobileMenuHidden();
    observeMobileMenuState();
  }

  // The mobile menu (#page-menu) stays in the DOM when closed. Setting only
  // aria-hidden is not reliable across screen readers, so when the menu is not
  // open we also mark it `inert` (removes it from the a11y tree and tab order);
  // when open we clear both so its controls work. The open state is reflected
  // by the `.reveal` class that theme.js toggles.
  function syncMobileMenuHidden() {
    var menu = document.getElementById('page-menu');
    if (!menu) return;
    var isOpen = menu.classList.contains('reveal');
    if (isOpen) {
      menu.removeAttribute('aria-hidden');
      menu.removeAttribute('inert');
      try { menu.inert = false; } catch (e) {}
    } else {
      menu.setAttribute('aria-hidden', 'true');
      menu.setAttribute('inert', '');
      try { menu.inert = true; } catch (e) {}
    }
  }

  function observeMobileMenuState() {
    var menu = document.getElementById('page-menu');
    if (!menu || menu.__a11yStateObserved) return;
    menu.__a11yStateObserved = true;
    new MutationObserver(syncMobileMenuHidden).observe(menu, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // The theme's in-page modals (#search-modal, #page-menu) have no focus trap:
  // the close button sits at the top of the modal, so after the search input
  // Tab moves into the page behind the modal and the close button is never
  // reached by keyboard. Constrain Tab to the open modal so every control,
  // including the close button, is reachable. (WCAG 2.1.1 / 2.4.3)
  function setupModalFocusTrap() {
    if (window.__a11yModalTrap) return;
    window.__a11yModalTrap = true;

    function focusables(modal) {
      var sel = 'a[href], button:not([disabled]), input:not([disabled]), ' +
        'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      return [].slice.call(modal.querySelectorAll(sel)).filter(function(el) {
        if (el.getAttribute('tabindex') === '-1') return false;
        var rect = el.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      var modal = document.querySelector('.theme-modal.reveal');
      if (!modal) return;
      var items = focusables(modal);
      if (!items.length) return;

      // Fully manage Tab within the modal rather than only guarding the edges:
      // some third-party widgets (e.g. the search autocomplete) inject focusable
      // nodes outside the modal and can steal a Tab step, so we always compute
      // the next modal element ourselves and move focus there.
      e.preventDefault();
      var active = document.activeElement;
      var idx = items.indexOf(active);
      var next;
      if (idx === -1) {
        next = e.shiftKey ? items[items.length - 1] : items[0];
      } else {
        next = items[(idx + (e.shiftKey ? -1 : 1) + items.length) % items.length];
      }
      next.focus();
    }, true);
  }

  function enhanceMegaMenuKeyboard() {
    if (document.documentElement.getAttribute('data-mega-menu-a11y')) return;

    var nav = document.querySelector('.site-control__inline-links .multi-level-nav.reveal-on-hover');
    if (!nav || typeof jQuery === 'undefined') return;

    document.documentElement.setAttribute('data-mega-menu-a11y', 'true');

    var megaLinks = nav.querySelectorAll('.tier-1 .contains-mega-menu > a.has-children');
    megaLinks.forEach(function(link) {
      if (!link.hasAttribute('aria-expanded')) link.setAttribute('aria-expanded', 'false');
      if (!link.id) link.id = 'mega-menu-' + (link.textContent || '').trim().toLowerCase().replace(/\s+/g, '-');
      var submenu = link.parentElement && link.parentElement.querySelector('ul.nav-columns, ul.nav-rows');
      if (submenu) {
        submenu.setAttribute('role', 'menu');
        if (link.id) submenu.setAttribute('aria-labelledby', link.id);
      }
    });

    function isFocusInsideMegaMenu(el) {
      if (!el || !nav.contains(el)) return false;
      return !!(el.closest('.tier-1 .contains-mega-menu') || el.closest('.tier-2, .tier-3'));
    }

    function getOpenTier2() {
      return nav.querySelector('.tier-2.tier-appeared');
    }

    function getOpenTrigger() {
      return nav.querySelector('.contains-mega-menu > a.has-children[aria-expanded="true"]');
    }

    // Visible, focusable links inside the open mega panel, in DOM order.
    function visibleFocusables(container) {
      return [].slice.call(container.querySelectorAll('a[href], button')).filter(function(el) {
        var rect = el.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      });
    }

    // Top-level nav links in order. The visible mega panel (tier-2) is appended at
    // the end of the nav while the original submenu is display:none, so natural Tab
    // order skips the panel entirely. We manage Tab manually to fix this.
    function topLevelAnchors() {
      var list = nav.querySelector('.tier-1 > ul, .tier-1 > ol');
      if (!list) return [];
      return [].slice.call(list.children).map(function(li) {
        return li.querySelector(':scope > a');
      }).filter(Boolean);
    }

    // Move focus to an adjacent top-level link when tabbing out of the panel.
    // If that link is itself a mega menu, open it; otherwise close the panel.
    function moveToTopLink(target) {
      if (!target) {
        closeMegaMenus();
        return;
      }
      if (target.closest('.contains-mega-menu')) {
        target.focus();
        openMegaMenu(target);
      } else {
        closeMegaMenus();
        target.focus();
      }
    }

    // theme.js binds its mega-menu handlers on a separate jQuery instance, so a
    // global jQuery(link).trigger('forceopen') never reaches them. Dispatching a
    // native bubbling CustomEvent reaches theme.js's delegated document listener.
    function fireNavEvent(link, type) {
      link.dispatchEvent(new CustomEvent(type, { bubbles: true }));
    }

    function closeMegaMenus() {
      if (typeof theme !== 'undefined' && theme.closeOpenMenuItem) {
        theme.closeOpenMenuItem();
      } else {
        nav.querySelectorAll('.contains-mega-menu > a.has-children[aria-expanded="true"]').forEach(function(link) {
          fireNavEvent(link, 'forceclose');
        });
      }
      nav.querySelectorAll('.contains-mega-menu > a.has-children').forEach(function(link) {
        link.setAttribute('aria-expanded', 'false');
        link.removeAttribute('aria-controls');
      });
    }

    function openMegaMenu(link) {
      if (!link) return;
      var isOpen = link.getAttribute('aria-expanded') === 'true' && nav.querySelector('.tier-2.tier-appeared');
      if (isOpen) return;

      // Don't pre-close the currently open menu: theme.js's forceopen resets the
      // sibling tier-1 link itself, and calling closeOpenMenuItem() here schedules
      // a delayed tier removal that would wipe out the menu we're about to open.
      nav.querySelectorAll('.contains-mega-menu > a.has-children').forEach(function(other) {
        if (other !== link) {
          other.setAttribute('aria-expanded', 'false');
          other.removeAttribute('aria-controls');
        }
      });

      fireNavEvent(link, 'forceopen');
      link.setAttribute('aria-expanded', 'true');
      link.setAttribute('aria-controls', 'menu-tier-2');
    }

    var closeTimer = null;

    function cancelScheduledClose() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function scheduleClose() {
      cancelScheduledClose();
      closeTimer = setTimeout(function() {
        closeTimer = null;
        if (!isFocusInsideMegaMenu(document.activeElement)) closeMegaMenus();
      }, 150);
    }

    megaLinks.forEach(function(link) {
      function handleOpen() {
        cancelScheduledClose();
        openMegaMenu(link);
      }
      link.addEventListener('focus', handleOpen);
      link.addEventListener('focusin', handleOpen);
    });

    nav.addEventListener('focusin', function(event) {
      if (isFocusInsideMegaMenu(event.target)) cancelScheduledClose();
    });

    nav.addEventListener('focusout', function() {
      scheduleClose();
    });

    nav.addEventListener('keydown', function(event) {
      var topLink = event.target.closest('.tier-1 .contains-mega-menu > a.has-children');
      if (topLink && event.key === ' ') {
        event.preventDefault();
        openMegaMenu(topLink);
      }
      if (event.key === 'Escape' && getOpenTier2()) {
        event.preventDefault();
        var expanded = getOpenTrigger();
        closeMegaMenus();
        if (expanded) expanded.focus();
        return;
      }

      // Manage Tab so the open mega panel is reachable in a logical order:
      // trigger -> first panel item ... last panel item -> next top-level link.
      if (event.key === 'Tab') {
        var tier2 = getOpenTier2();
        var trigger = getOpenTrigger();
        if (!tier2 || !trigger) return;
        var items = visibleFocusables(tier2);
        if (!items.length) return;
        var active = document.activeElement;
        var tops = topLevelAnchors();
        var triggerIndex = tops.indexOf(trigger);

        if (!event.shiftKey) {
          if (active === trigger) {
            event.preventDefault();
            items[0].focus();
          } else if (items.indexOf(active) === items.length - 1) {
            event.preventDefault();
            moveToTopLink(tops[triggerIndex + 1]);
          }
        } else {
          if (active === items[0]) {
            event.preventDefault();
            trigger.focus();
          } else if (active === trigger) {
            event.preventDefault();
            moveToTopLink(tops[triggerIndex - 1]);
          }
        }
      }
    });
  }

  // Top-level nav items with a SIMPLE dropdown (e.g. "DISCOVER") render as
  // `.contains-children` WITHOUT `.contains-mega-menu`, so enhanceMegaMenuKeyboard
  // skips them. theme.js only toggles `.reveal-child` on Enter and never opens on
  // focus, syncs aria-expanded, supports Space, or closes on Esc. Wire that up so
  // these submenus are fully keyboard-operable. (WCAG 2.1.1)
  function enhanceSimpleDropdownKeyboard() {
    if (document.documentElement.getAttribute('data-simple-dropdown-a11y')) return;
    var nav = document.querySelector('.multi-level-nav.reveal-on-hover');
    if (!nav) return;
    document.documentElement.setAttribute('data-simple-dropdown-a11y', 'true');

    var TRIGGER = '.tier-1 .contains-children:not(.contains-mega-menu) > a.has-children';

    function triggers() {
      return [].slice.call(nav.querySelectorAll(TRIGGER));
    }
    function setState(trigger, open) {
      var li = trigger.parentElement;
      li.classList.toggle('reveal-child', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function closeAll(except) {
      triggers().forEach(function(t) {
        if (t.parentElement === except) return;
        setState(t, false);
      });
    }
    function openTrigger() {
      return triggers().filter(function(t) {
        return t.getAttribute('aria-expanded') === 'true';
      })[0];
    }

    // Open on focus (matching the mega-menu behaviour) and close siblings.
    nav.addEventListener('focusin', function(e) {
      var trigger = e.target.closest(TRIGGER);
      if (trigger) {
        closeAll(trigger.parentElement);
        setState(trigger, true);
        return;
      }
      var li = e.target.closest('.tier-1 .contains-children:not(.contains-mega-menu)');
      closeAll(li || null);
    });

    nav.addEventListener('keydown', function(e) {
      var trigger = e.target.closest(TRIGGER);
      if (trigger && (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar')) {
        // Handle here and stop the event reaching theme.js's document-level
        // handler, which would otherwise toggle reveal-child a second time.
        e.preventDefault();
        e.stopPropagation();
        setState(trigger, trigger.getAttribute('aria-expanded') !== 'true');
        return;
      }
      if (e.key === 'Escape') {
        var open = openTrigger();
        if (open) {
          e.preventDefault();
          setState(open, false);
          open.focus();
        }
      }
    });

    // Close when focus leaves the whole nav.
    nav.addEventListener('focusout', function() {
      setTimeout(function() {
        if (!nav.contains(document.activeElement)) closeAll(null);
      }, 0);
    });
  }

  function labelUnlabeledSelects() {
    document.querySelectorAll('select:not([aria-label]):not([aria-labelledby])').forEach(function(select) {
      if (select.id) {
        var label = document.querySelector('label[for="' + select.id + '"]');
        if (label) return;
      }
      var context = select.closest('.gf-option-block, .globo-dropdown-custom, .spf-product-card, .product-area, form');
      var name = '';
      if (context) {
        var heading = context.querySelector('.gf-block-title, .h3, h3, legend, label');
        if (heading) name = stripHtml(heading.textContent);
      }
      if (select.name === 'sort_by' || select.classList.contains('sort-by')) {
        select.setAttribute('aria-label', 'Sort by');
      } else if (select.classList.contains('spf-product__variants')) {
        var card = select.closest('.spf-product-card');
        var title = card && card.querySelector('.spf-product-card__title');
        select.setAttribute('aria-label', (title ? stripHtml(title.textContent) + ' - ' : '') + 'Options');
      } else if (name) {
        select.setAttribute('aria-label', name);
      } else {
        select.setAttribute('aria-label', 'Filter options');
      }
    });
  }

  function removeEmptyHeadings() {
    document.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function(heading) {
      if (!stripHtml(heading.innerHTML)) heading.remove();
    });
  }

  // Normalize heading levels within the main content so there are no skipped
  // levels (e.g. h1 -> h3). Uses a stack of the natural tag levels to compute
  // a sequential level for each heading, which keeps sibling sections at the
  // same level. Only the exposed aria-level is changed — visual styling and
  // the underlying tag are left untouched.
  function normalizeHeadingLevels() {
    var scope = document.querySelector('main, #MainContent, [role="main"]') || document.body;
    var headings = scope.querySelectorAll('h1, h2, h3, h4, h5, h6');
    var stack = [];
    headings.forEach(function(h) {
      if (!stripHtml(h.innerHTML)) return;
      var natural = parseInt(h.tagName.slice(1), 10);
      while (stack.length && stack[stack.length - 1] >= natural) stack.pop();
      var effective = stack.length + 1;
      stack.push(natural);
      if (effective !== natural) {
        if (h.getAttribute('role') !== 'heading') h.setAttribute('role', 'heading');
        if (h.getAttribute('aria-level') !== String(effective)) {
          h.setAttribute('aria-level', String(effective));
        }
      } else if (h.getAttribute('aria-level')) {
        h.removeAttribute('aria-level');
        h.removeAttribute('role');
      }
    });
  }

  // Keep a single semantic <h1> per page. Third-party widgets (e.g. Klaviyo
  // signup popups) inject their own <h1>, producing duplicate top-level
  // headings. Demote any extra <h1> to heading level 2 for assistive tech.
  function demoteDuplicateH1s() {
    var h1s = document.querySelectorAll('h1');
    if (h1s.length < 2) return;
    var mainH1 = document.querySelector('main h1, #MainContent h1, .h1-banner') || h1s[0];
    h1s.forEach(function(h1) {
      if (h1 === mainH1) return;
      if (h1.getAttribute('aria-level') === '2') return;
      h1.setAttribute('role', 'heading');
      h1.setAttribute('aria-level', '2');
    });
  }

  function enhanceWishlistApp() {
    document.querySelectorAll('.wishlist-hero-list-card-footer-delete, button[class*="wishlist"][class*="delete"]').forEach(function(btn) {
      if (btn.getAttribute('data-a11y-enhanced')) return;
      btn.setAttribute('data-a11y-enhanced', 'true');
      var card = btn.closest('[class*="wishlist"], [class*="list-card"]');
      var titleEl = card && card.querySelector('[class*="title"], h2, h3, h4');
      var productName = titleEl ? stripHtml(titleEl.textContent) : 'item';
      if (!btn.getAttribute('aria-label')) {
        btn.setAttribute('aria-label', 'Remove ' + productName + ' from wishlist');
      }
      btn.setAttribute('title', 'Remove from wishlist');
      var svg = btn.querySelector('svg');
      if (svg) svg.setAttribute('aria-hidden', 'true');
    });

    document.querySelectorAll('[class*="wishlist"] [role="group"], .button-group[role="group"]').forEach(function(group) {
      if (group.querySelector('.spf-product__form-btn-addtocart, [class*="addtocart"], button')) {
        group.removeAttribute('role');
      }
    });
  }

  function enhanceGloboProductCards() {
    document.querySelectorAll('.spf-product-card').forEach(function(card) {
      if (card.getAttribute('data-a11y-enhanced')) return;
      var imageLink = card.querySelector('.spf-product-card__image-wrapper');
      var titleLink = card.querySelector('.spf-product-card__title a');
      if (!imageLink || !titleLink || imageLink === titleLink) return;
      if (imageLink.getAttribute('href') !== titleLink.getAttribute('href')) return;

      card.setAttribute('data-a11y-enhanced', 'true');
      var titleText = stripHtml(titleLink.textContent);
      imageLink.setAttribute('aria-label', 'View ' + titleText);
      card.querySelectorAll('.spf-product-card__image').forEach(function(img) {
        img.setAttribute('alt', '');
        img.setAttribute('aria-hidden', 'true');
      });

      var titleContainer = titleLink.parentElement;
      var span = document.createElement('span');
      span.className = 'spf-product-card__title-text';
      span.textContent = titleText;
      titleLink.replaceWith(span);
    });
  }

  function enhanceContactConciergeForm() {
    var form = document.querySelector('#popup2 form, #contact_form');
    if (!form || form.getAttribute('data-a11y-enhanced')) return;
    form.setAttribute('data-a11y-enhanced', 'true');
    var fields = [
      ['contact[email]', 'Email', true],
      ['contact[name]', 'Name', true],
      ['contact[phone]', 'Phone Number', false],
      ['contact[body]', 'Your Message', true],
      ['contact[sku]', 'SKU', false],
      ['contact[productname]', 'Product Name', false]
    ];
    fields.forEach(function(field) {
      var input = form.querySelector('[name="' + field[0] + '"]');
      if (!input || input.id) return;
      var id = 'ContactForm-' + field[0].replace(/\[|\]/g, '');
      input.id = id;
      if (!form.querySelector('label[for="' + id + '"]')) {
        var label = document.createElement('label');
        label.setAttribute('for', id);
        label.textContent = field[1] + (field[2] ? ' *' : '');
        label.className = 'visually-hidden';
        input.parentNode.insertBefore(label, input);
      }
      if (field[2]) input.setAttribute('required', '');
      if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', field[1]);
    });
    var close = document.querySelector('#popup2 .close');
    if (close && !close.getAttribute('aria-label')) {
      close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
      close.setAttribute('aria-label', 'Close contact form');
    }
  }

  // The PDP "GURHAN VIP Experience" block embeds a mailto: share link whose
  // visible text is "Contact Now" but whose title renders the missing locale
  // key "Translation missing: ...share_on_email", with no aria-label and an
  // unhidden icon. It lives in the product template (not the social-sharing
  // snippet), so patch it at runtime. Also covers any other mailto share
  // button still carrying the broken title/class.
  function enhanceShareEmailLink() {
    document.querySelectorAll('a.btn--share[href^="mailto:"]').forEach(function(link) {
      if (link.getAttribute('data-a11y-enhanced')) return;
      link.setAttribute('data-a11y-enhanced', 'true');

      var label = 'Share this page via email';
      link.setAttribute('aria-label', label);
      link.setAttribute('title', label);
      link.classList.remove('share-pinterest');
      link.classList.add('share-email');

      // Rebuild a user-friendly mailto from the actual page. The template's
      // {{ share_permalink }} is blank inside this custom-liquid block, so the
      // original href points only at the shop root.
      var pageUrl = window.location.href.split('#')[0];
      var title = (document.title || 'GURHAN').replace(/\s+/g, ' ').trim();
      link.setAttribute(
        'href',
        'mailto:?subject=' + encodeURIComponent(title + ' from GURHAN') +
        '&body=' + encodeURIComponent('Check out this product: ' + pageUrl)
      );

      var svg = link.querySelector('svg');
      if (svg) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('role', 'img');
        svg.setAttribute('focusable', 'false');
      }
    });
  }

  // Some third-party apps grab keyboard focus a few seconds after load: the
  // Zinrelo rewards iframe (#zrl_iframe) calls focus() on itself (~5s), and
  // the Klaviyo signup popup focuses its first field when it appears (~10s).
  // Either one yanks focus out of the page mid-navigation, so the next Tab
  // restarts from the top. We can't stop their internal focus() call, but we
  // can detect a focus move INTO one of these widgets that did not result
  // from the user's own Tab or click, and send focus back where it was.
  function setupFocusGuard() {
    if (window.__a11yFocusGuard) return;
    window.__a11yFocusGuard = true;

    var STEALER_SELECTOR = '#zrl_iframe, [id^="zrl_"], .klaviyo-form, .klaviyo-form-div, [class*="kl-private"], [data-testid="klaviyo-form"]';
    var tabAt = 0;            // last Tab keydown
    var pointerAt = 0;        // last pointer/touch down
    var lastGoodFocus = null; // last non-widget element the user was on
    var restoring = false;
    var restores = [];        // recent restore timestamps, to stop a focus war

    function now() {
      return (window.performance && performance.now) ? performance.now() : +new Date();
    }
    function isStealer(el) {
      return !!(el && el.closest && el.closest(STEALER_SELECTOR));
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Tab') tabAt = now();
    }, true);
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function(type) {
      document.addEventListener(type, function() { pointerAt = now(); }, true);
    });

    document.addEventListener('focusin', function(e) {
      if (restoring) return;
      var target = e.target;

      if (!isStealer(target)) {
        // Remember a safe, real place to return focus to.
        if (target && target !== document.body && document.contains(target)) {
          lastGoodFocus = target;
        }
        return;
      }

      var t = now();
      var viaTab = (t - tabAt) < 120;        // focus moved as part of Tab order
      var viaClick = (t - pointerAt) < 1500; // user opened/clicked the widget
      if (viaTab || viaClick) return;        // legitimate — leave it alone

      // Don't fight a widget that keeps re-grabbing on every frame.
      restores = restores.filter(function(ts) { return t - ts < 2000; });
      if (restores.length >= 5) return;
      restores.push(t);

      restoring = true;
      try {
        if (target.blur) target.blur();
        if (lastGoodFocus && document.contains(lastGoodFocus) && lastGoodFocus.offsetParent !== null) {
          lastGoodFocus.focus({ preventScroll: true });
        } else if (document.activeElement && isStealer(document.activeElement) && document.activeElement.blur) {
          document.activeElement.blur();
        }
      } catch (err) {}
      restoring = false;
    }, true);
  }

  function runEnhancements() {
    markTrackingPixelsDecorative();
    updateNavWishlistLabel();
    updateNavCartLabel();
    enhanceSearchCloseButton();
    enhanceMobileMenuClose();
    labelUnlabeledSelects();
    removeEmptyHeadings();
    demoteDuplicateH1s();
    normalizeHeadingLevels();
    enhanceWishlistApp();
    enhanceGloboProductCards();
    enhanceContactConciergeForm();
    enhanceShareEmailLink();
  }

  var observer;
  function startObserver() {
    if (!observer) {
      observer = new MutationObserver(scheduleEnhancements);
    }
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Run enhancements with the observer temporarily disconnected so the
  // attribute writes we make don't re-trigger the observer (which would
  // otherwise loop and spin the CPU on every mutation).
  function safeRunEnhancements() {
    if (observer) observer.disconnect();
    try {
      runEnhancements();
    } finally {
      startObserver();
    }
  }

  var scheduleHandle = null;
  function scheduleEnhancements() {
    if (scheduleHandle) return;
    scheduleHandle = (window.requestAnimationFrame || window.setTimeout)(function() {
      scheduleHandle = null;
      safeRunEnhancements();
    }, 150);
  }

  setupFocusGuard();
  setupModalFocusTrap();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      safeRunEnhancements();
      startObserver();
    });
  } else {
    safeRunEnhancements();
    startObserver();
  }

  window.addEventListener('load', function() {
    enhanceMegaMenuKeyboard();
    enhanceSimpleDropdownKeyboard();
    scheduleEnhancements();
  });

  document.addEventListener('cart:updated', updateNavCartLabel);
})();
